import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import {useNavigate } from "react-router-dom";

export default function DeleteConversationModal({
    id,fetchData,cancelModal
}) {


  // styled
    

  const [isLoading, setIsLoading] = useState(false);
  const [complete,setComplete] = useState(false)
  const {user} = useAuthContext();
  const navi = useNavigate();

  const handleDelete = async () => {
    setIsLoading(true);
  
    try {
      const deleteResponse = await axios.delete(`${ApiConnectionString}/api/convo/${id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
  
      if (deleteResponse.status === 200) {
        setComplete(true);
        fetchData();
      }
    } catch (error) {
      console.error('Error deleting message:', error);
    } finally {
      setIsLoading(false); 
    }
  };
  

  if(isLoading){
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">      
        <LoadingSpinner />
            <div className="send-modal-footer">           
            </div>
          </div>
        </div>
      );
  }
  else{
    if(complete){
        return (
            <div className="send-modal-overlay">
              <div className="send-modal">
              <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Conversation Deleted</p></div> 
              <p>The conversation was successfully deleted.</p>
                <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
                <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
                </div>
              </div>
            </div>
          );
    }else{
        return (
            <div className="send-modal-overlay">
              <div className="send-modal">

              <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Conversation</p></div> 
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <p>Are you sure you want to delete this conversation?</p>
        
                <div className="send-modal-footer">
                  <button
                    className="saveChanges-button mx-3"
                    onClick={handleDelete}
                    disabled={isLoading}
                  > Confirm
                   
                  </button>
                  <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
                </div>
              </div>
            </div>
          );
    }
  }


}
